import React, { useCallback } from "react";
import { useLangContext } from "../../providers/LangProvider/LangProviderContext";
import { useGTMEvent } from "../GoogleTagManager/googleTagManagerHooks";
import { LangChooserButtonProps } from "./components/lang-chooser-button/LangChooserButton";
import { LangChooserDropdown } from "./components/lang-chooser-dropdown/LangChooserDropdown";
import { LangChooserSlider } from "./components/lang-chooser-slider/LangChooserSlider";
import { LANG_CHOOSER_TYPES } from "./lang-chooser-constants";
import { LangChooserWrapperStyled, } from './styled/LangChooserStyled';

type ILangChooserType = typeof LANG_CHOOSER_TYPES[keyof typeof LANG_CHOOSER_TYPES]

interface ILangChooserProps {
    className?: string,
    isHideButtonArrowIcon?: boolean,
    gtmModule?: string,
    toggleButtonComponent?: React.FC<LangChooserButtonProps>,
    type?: ILangChooserType
}
export const LangChooser = ({
    className,
    isHideButtonArrowIcon,
    gtmModule,
    toggleButtonComponent,
    type = LANG_CHOOSER_TYPES.dropdown,
}: ILangChooserProps) => {
    const { locale, setLocale, availableLocales } = useLangContext();
    const { handleGTMClick } = useGTMEvent(gtmModule ? { module: gtmModule } : {});
    const changeLang = useCallback((locale?: string | null ) => {
        setLocale(locale || 'en');
        handleGTMClick({ component: 'LangChooser', newLocale: locale })
    }, [handleGTMClick, setLocale]);

    if (type === LANG_CHOOSER_TYPES.slider) {
        return (
            <LangChooserWrapperStyled className={className}>
                <LangChooserSlider
                    isHideButtonArrowIcon={isHideButtonArrowIcon}
                    locales={availableLocales}
                    locale={locale || 'en'}
                    onSelectLang={changeLang}
                    toggleButtonComponent={toggleButtonComponent}
                />
            </LangChooserWrapperStyled>
        )

    }
    return (
        <LangChooserWrapperStyled className={className}>
            <LangChooserDropdown
                locales={availableLocales}
                locale={locale || 'en'}
                onSelectLang={changeLang}
                toggleButtonComponent={toggleButtonComponent}
            />
        </LangChooserWrapperStyled>
    )
}
